__webpack_require__.p = "https://ci-admin-otrip.clik.vn/";